import React from 'react';
import cn from 'classnames';

import { RentalAsset } from '@kaltura-ott/tvpil-shared/lib/rhino/data/rental/types';

import RentalsCardContainer from 'components/widgets/CardView/Rentals/RentalsCardContainer/RentalsCardContainer';
import DynamicRailViewer from 'components/widgets/Rail/components/DynamicRailViewer/DynamicRailViewer';
import { useRailContext } from 'components/widgets/Rail/components/RailProvider/RailProvider';
import Title from 'components/widgets/Rail/components/Title/Title';
import { useApplyStyles } from 'components/widgets/Rail/hooks/useApplyStyles/useApplyStyles';
import { useWidgetContext } from 'context/widgetProvider/widgetProvider';

import styles from './RentalsRailContainer.module.scss';

const RentalsRailContainer = () => {
  // using version v2 of the rail provider
  const { wrapperRef, refElementInner, componentHeight } = useRailContext();
  const {
    settings,
    data: { hasNextPage, totalCount, items },
    data,
  } = useWidgetContext<RentalAsset>();
  const handleRef = useApplyStyles(settings);
  return (
    <div ref={handleRef} className={cn(styles.container)}>
      <div ref={refElementInner}>
        <Title
          hasNextPage={!!hasNextPage}
          totalCount={totalCount}
          itemsLength={items?.length}
          forwardHeaderRef={handleRef}
          railSettings={settings}
        />
        <div
          ref={wrapperRef}
          style={{
            height: componentHeight,
          }}
        >
          <DynamicRailViewer railData={data}>
            {({ imageHeight, itemWidth, item }) => (
              <RentalsCardContainer imageHeight={imageHeight} itemWidth={itemWidth} item={item} />
            )}
          </DynamicRailViewer>
        </div>
      </div>
    </div>
  );
};

export default RentalsRailContainer;
